import React, { useState, useRef, useEffect } from "react";
import {
    Typography,
    Input,
    Table,
    Dropdown,
    Menu,
    Icon,
    Row,
    Modal,
    Col,
    Button,
    Select,
    Divider,
    message,
    Upload,
} from "antd";
import { ExclamationCircleOutlined, PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import {
    resolveInaamCustomerComplaintsApi,
    deleteInaamCustomerComplaintsApi,
    replycustomercomplains,
    fetchmailreplies,
} from "utils/apiService";

import isDev from "server";
import axios from "axios";
import userIcon from "media/complaint-user-icon.svg";
import cardIcon from "media/complaint-card-icon.svg";
import contactIcon from "media/complaint-contact-icon.svg";
import emailIcon from "media/complaint-email-icon.svg";
import messageIcon from "media/complaint-message-icon.svg";
import EmptyThread from "media/emptythread.svg";
import { max } from "lodash";
import TextArea from "antd/lib/input/TextArea";
import EditorBox from "../../components/EditorBox/EditorBox";
import { uuid } from "@antv/x6/lib/util/string/uuid";
import moment from "moment";
import { parse } from "@fortawesome/fontawesome-svg-core";

const { Text } = Typography;

function DataCard(props) {
    return (
        <Row
            type='flex'
            gutter={[12, 12]}
            style={{
                flexGrow: 1,
                flexBasis: "50%",
                padding: "20px 0",
            }}>
            <div style={{ width: "52px" }}>
                <img
                    src={props.imgSrc}
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    alt={"Total users till date illustration"}
                />
            </div>
            <div style={{ flex: 1 }}>
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#747474",
                    }}>
                    {props.text}
                </Text>
                <br />
                {props.data}
            </div>
        </Row>
    );
}

export default function CustomerComplaintsTable(props) {
    const { data } = props;

    const [deleteModal, setDeleteModal] = useState(false);
    const deleteComplaints = useRef([]);
    const [replylist, setReplylist] = useState(null);
    const [discardModal, setDiscardModal] = useState(false);

    const [rowDetailModal, setRowDetailModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState({
        card_number: "",
        date_created: "",
        email: "",
        is_resolved: false,
        key: "",
        message: "",
        name: "",
        uuid: "",
        contact_number: "",
    });

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            props.handleRowSelection(selectedRowKeys);
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    const [replyEmail, setReplyEmail] = useState(false);
    const [emailIsSending, setEmailIsSending] = useState(false);
    const [sendEmail, setSendEmail] = useState({
        uuid: "",
        subject: "",
        cc: "[]",
        body: "<p>Dear Valued Customers</p><p>Thank you for reaching Nujoom Customer Service This is a response to the message that you sent through Nujoom App.</p>",
        bcc: "",
        attachments: [],
    });

    useEffect(() => {
        setSendEmail({
            uuid: selectedRow.uuid,
            subject: [],
            cc: "[]",
            body: "<p>Dear Valued Customers</p><p>Thank you for reaching Nujoom Customer Service This is a response to the message that you sent through Nujoom App.</p>",
            bcc: "",
            attachments: [],
        });
    }, [replyEmail]);

    
    const modalDetails = [
        {
            imgSrc: userIcon,
            text: "Raised By",
            data: (
                <Text style={{ fontSize: "16px", color: "black", fontWeight: "bold" }}>
                    {props.loading ? "..." : selectedRow?.name}
                </Text>
            ),
        },
        {
            imgSrc: cardIcon,
            text: "Nujoom Card Number",
            data: (
                <Text style={{ fontSize: "16px", color: "black", fontWeight: "bold" }}>
                    {props.loading ? "..." : selectedRow?.card_number}
                </Text>
            ),
        },
        {
            imgSrc: contactIcon,
            text: "Phone Number",
            data: (
                <Text style={{ fontSize: "16px", color: "black", fontWeight: "bold" }}>
                    {props.loading ? "..." : selectedRow?.contact_number}
                </Text>
            ),
        },
        {
            imgSrc: emailIcon,
            text: "Email Address",
            data: (
                <Text style={{ fontSize: "16px", color: "black", fontWeight: "bold" }}>
                    {props.loading ? "..." : selectedRow?.email}
                </Text>
            ),
        },
    ];

    const columns = [
        {
            title: "Raised By",
            dataIndex: ["name", "card_number"],
            key: "username",
            render: (_, row) => {
                return (
                    <Row type='flex' style={{ flexDirection: "column" }}>
                        <Text
                            style={{
                                fontStyle: "normal",
                                fontWeight: "bold",
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#181818",
                                maxWidth: "300px",
                                overflowWrap: "break-word",
                            }}>
                            {row.name ?? "-"}
                        </Text>
                        {row.card_number ? (
                            <Text style={{ fontStyle: "normal", fontSize: "14px", lineHeight: "24px" }}>
                                {row.card_number}
                            </Text>
                        ) : null}
                    </Row>
                );
            },
        },
        {
            title: "Email Address",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Contact No.",
            dataIndex: "contact_number",
            key: "contactNumber",
        },
        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            render: (message) => (
                <div
                    style={{
                        lineHeight: "1.5em",
                        maxHeight: "3em",
                        overflow: "hidden",
                        maxWidth: "250px",
                        textOverflow: "ellipsis",
                        wordBreak: "break-word",
                    }}>
                    {message}
                </div>
            ),
        },
        {
            title: "Raised On",
            dataIndex: "date_created",
            key: "raisedOn",
            render: (raisedOn) => <div style={{ whiteSpace: "nowrap" }}>{raisedOn}</div>,
        },
        {
            title: "",
            dataIndex: "uuid",
            key: "uuid",
            render: (uuid) => {
                return (
                    <div style={{ width: "16px" }}>
                        <Dropdown
                            placement={"bottomLeft"}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            style={{ marginLeft: "0" }}
                            overlay={
                                <Menu>
                                    <Menu.Item
                                        onClick={(e) => {
                                            e.domEvent.stopPropagation();
                                            resolveInaamCustomerComplaintsApi({
                                                requestData: {
                                                    uuid: [uuid],
                                                    status: props.noAction ? "unresolved" : "resolved",
                                                },
                                                res200Callback: () => {
                                                    props.updatePage(data.pageNum);
                                                },
                                            });
                                        }}>
                                        <Text style={{ color: "#181818" }}>
                                            Mark as {props.noAction ? "unresolved" : "resolved"}
                                        </Text>
                                    </Menu.Item>
                                    <Menu.Item
                                        onClick={(e) => {
                                            e.domEvent.stopPropagation();
                                            deleteComplaints.current = [uuid];
                                            setDeleteModal(true);
                                        }}>
                                        <Text style={{ color: "#F5222D" }}>Delete</Text>
                                    </Menu.Item>
                                </Menu>
                            }>
                            <Icon
                                type='more'
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                style={{ fontSize: "16px", color: "#747474", marginLeft: "52px" }}
                            />
                        </Dropdown>
                    </div>
                );
            },
        },
    ];

    // return data.customerComplaints?.length > 0 ? (
    return (
        <>
            <Table
                rowSelection={props.noAction ? null : rowSelection}
                columns={(function () {
                    // if (props.noAction) {
                    // 	return columns.filter((item) => item.key != "x");
                    // }
                    return columns;
                })()}
                dataSource={data.customerComplaints}
                pagination={{
                    showQuickJumper: true,
                    current: data.pageNum,
                    pageSize: data.pageSize,
                    total: data.pageSize * data.totalPages,
                }}
                style={{ overflow: "none" }}
                onChange={(pagination) => {
                    props.updatePage(pagination.current);
                }}
                onRow={(obj) => ({
                    onClick: () => {
                        setSelectedRow({ ...obj });
                        setRowDetailModal(true);
                        fetchmailreplies({
                            requestData: { uuid: obj.uuid },
                            resCallback: () => {},
                            res200Callback: (res) => {
                                setReplylist(res.data.email_replies);
                            },
                        });
                    },
                })}
                loading={props.loading}
            />
            <Modal
                centered
                visible={deleteModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setDeleteModal(false)}
                footer={null}>
                <Row className='modal-row'>
                    <Row>
                        <Icon
                            type='delete'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Delete item
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                        <Col span={24}>
                            <Text>Are you sure you want to delete this Customer Complaint?</Text>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={18}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    boxShadow: "none",
                                    borderRadius: "20px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    color: "#181818",
                                }}
                                onClick={() => setDeleteModal(false)}>
                                Cancel
                            </Button>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={6}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "2px",
                                    border: "none",
                                    backgroundColor: "#C91713",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    deleteInaamCustomerComplaintsApi({
                                        requestData: {
                                            uuid: deleteComplaints.current,
                                        },
                                        res200Callback: () => {
                                            setDeleteModal(false);
                                            props.updatePage(data.pageNum);
                                        },
                                    });
                                }}>
                                Delete
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Modal>
            <Modal
                centered
                visible={rowDetailModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setRowDetailModal(false)}
                footer={null}
                bodyStyle={{ flexDirection: "column", height: "100vh" }}
                style={{ minWidth: "640px", top: "0%", float: "right" }}>
                <Row className='modal-row' style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Row>
                        <Icon
                            type='mail'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Complaint
                        </Text>
                        <Text
                            style={{
                                fontWeight: "normal",
                                color: "#747474",
                                fontSize: "16px",
                                marginLeft: "20px",
                            }}>
                            {selectedRow.date_created}
                        </Text>
                    </Row>
                    <Row type='flex' align='middle' justify='space-between' style={{ marginTop: "24px" }}>
                        {modalDetails.map((rowDetail, index) => (
                            <DataCard
                                key={index}
                                text={rowDetail.text}
                                imgSrc={rowDetail.imgSrc}
                                data={rowDetail.data}
                            />
                        ))}
                        <DataCard
                            text={"Message"}
                            imgSrc={messageIcon}
                            data={
                                <Text
                                    style={{
                                        fontSize: "16px",
                                        color: "black",
                                        fontWeight: "normal",
                                        wordBreak: "break-word",
                                    }}>
                                    {props.loading ? "..." : selectedRow?.message}
                                </Text>
                            }
                        />
                    </Row>
                    <Divider />
                    <Row>
                        <Icon
                            type='message'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Thread
                        </Text>
                    </Row>
                    <div
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            margin: "30px -24px 56px",
                            padding: "0 24px",
                        }}>
                        {!replylist?.length ? (
                            <Row
                                type='flex'
                                justify='center'
                                align='middle'
                                style={{
                                    flexDirection: "column",
                                    flex: 1,
                                    height: "100%",
                                }}>
                                <img
                                    src={EmptyThread}
                                    style={{
                                        margin: "0 auto",
                                        height:"max",
                                        width: "max"
                                    }}
                                    alt='Empty Thread'
                                />

                                <Text style={{ textAlign: "center" }}>Your messages with the customer appear here</Text>
                            </Row>
                        ) : (
                            replylist?.map((reply) => (
                                <div
                                    key={reply.uuid}
                                    style={{
                                        width: "75%",
                                        backgroundColor: "#FAFAFA",
                                        padding: "16px",
                                        borderRadius: "8px",
                                        margin: "8px 0px",
                                        float: "right",
                                    }}>
                                    <div style={{ fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
                                        <span style={{ color: "#747474" }}>Cc:</span>{" "}
                                        {JSON.parse(reply.cc || "[]")?.join(", ")}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "22px",
                                            fontWeight: "bold",
                                            color: "#181818",
                                            marginTop: "12px",
                                        }}>
                                        {reply.subject}
                                    </div>
                                    <div
                                        style={{ fontSize: "14px", color: "#464646", marginTop: "8px" }}
                                        dangerouslySetInnerHTML={{ __html: reply.body }}></div>
                                    <div
                                        style={{
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            color: "#464646",
                                            marginTop: "8px",
                                        }}></div>
                                    <div
                                        style={{
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            color: "#464646",
                                            marginTop: "8px",
                                        }}>{`${reply.date_created}`}</div>
                                </div>
                            ))
                        )}
                    </div>

                    <Row style={{ padding: "16px 24px 0px", position: "absolute", bottom: "0", left: "0", right: "0" }}>
                        <Row
                            type='flex'
                            style={{
                                justifyContent: "space-around",
                            }}>
                            <Button
                                size='large'
                                style={{
                                    backgroundColor: "#FFFFFF",
                                    border: "1px solid #D9D9D9",
                                    borderRadius: "4px",
                                    textDecorationColor: "black",
                                    marginRight: "12px",
                                    flex: 1,
                                }}
                                disabled={props.noAction}
                                onClick={() => {
                                    setReplyEmail(true);
                                }}>
                                Write a New Message
                            </Button>
                            <Button
                                size='large'
                                style={{
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                    border: "none",
                                    borderRadius: "4px",
                                    marginLeft: "12px",
                                    flex: 1,
                                }}
                                onClick={() => {
                                    resolveInaamCustomerComplaintsApi({
                                        requestData: {
                                            uuid: [selectedRow.uuid],
                                            status: props.noAction ? "unresolved" : "resolved",
                                        },
                                        res200Callback: () => {
                                            setRowDetailModal(false);
                                            props.updatePage(data.pageNum);
                                        },
                                    });
                                }}>
                                Mark as {props.noAction ? "Unresolved" : "Resolved"}
                            </Button>
                        </Row>
                    </Row>
                </Row>
            </Modal>
            <Modal
                visible={replyEmail}
                destroyOnClose
                maskClosable={false}
                mask={false}
                onCancel={()=>{setDiscardModal(true)}}
                bodyStyle={{ padding: "16px", width: "512px", borderRadius: "10px" }}
                style={{ top: "100%", transform: "translate(-28% ,-100%)" }}
                footer={null}>
                <Row className='modal-row'>
                    <Row>
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "18px",
                            }}>
                            New Message
                        </Text>
                        <br />
                        <Text
                            style={{
                                fontWeight: "normal",
                                color: "#747474",
                                fontSize: "12px",
                            }}>
                            This message is sent through Nujoom service desk
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px", position: "relative", paddingBottom: "64px" }}>
                        <div
                            style={{
                                borderBottom: "1px solid #F2F2F2",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}>
                            <Text style={{ color: "#747474" }}>Cc</Text>
                            <div style={{ flex: 1, maxHeight: "50px", overflowY: "auto", marginRight: "-16px" }}>
                                <Select
                                    mode='tags'
                                    //  className='time-value-cohort-col-main-element'
                                    style={{ width: "100%" }}
                                    dropdownStyle={{ display: "none" }}
                                    maxTagTextLength={36}
                                    value={JSON.parse(sendEmail.cc)}
                                    tokenSeparators={[",", " "]}
                                    placeholder={"Add People to CC"}
                                    onChange={(e) => {
                                        setSendEmail({
                                            ...sendEmail,
                                            cc: JSON.stringify(e),
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <Input
                            className='ant-calendar-picker-input'
                            style={{
                                fontWeight: "600",
                                paddingLeft: "0px",
                                paddingRight: "0px",
                                borderBottom: "1px solid #F2F2F2",
                            }}
                            value={sendEmail.subject}
                            bordered={"false"}
                            onChange={(e) =>
                                setSendEmail({
                                    ...sendEmail,
                                    subject: e.target.value,
                                })
                            }
                            placeholder={"Subject"}
                        />
                        {/* <div> */}
                        <div style={{ maxHeight: "400px", overflowY: "auto", margin: "0 -16px", padding: "0 16px" }}>
                            <EditorBox
                                className='quill-editor-borderless quill-editor-toolbar-style'
                                replyemail={true}
                                value={sendEmail.body}
                                getText={(e) => {
                                    setSendEmail({
                                        ...sendEmail,
                                        body: e,
                                    });
                                }}
                                placeholder={"write Your message"}
                                style={{ display: "flex", flexDirection: "column" }}
                            />
                            <div style={{}}>
                                <Upload
                                    fileList={sendEmail.attachments}
                                    multiple={true}
                                    beforeUpload={(file) => {
                                        setSendEmail((sendEmail) => ({
                                            ...sendEmail,
                                            attachments: [...sendEmail.attachments, file],
                                        }));
                                        return false;
                                    }}
                                    onRemove={(file) => {
                                        const index = sendEmail.attachments.indexOf(file);
                                        const newFileList = sendEmail.attachments.slice();
                                        newFileList.splice(index, 1);
                                        setSendEmail({
                                            ...sendEmail,
                                            attachments: newFileList,
                                        });
                                    }}>
                                    <PaperClipOutlined
                                        className='hover-effect'
                                        style={{
                                            position: "absolute",
                                            left: "256px",
                                            bottom: "10px",
                                            zIndex: 10,
                                            fontSize: "18px",
                                            strokeWidth: "5",
                                            marginTop: "11px",
                                        }}
                                    />
                                </Upload>
                            </div>
                        </div>
                        {/* </div> */}
                        <div
                            style={{
                                display: "flex",
                                // flexDirection: "row",
                                position: "absolute",
                                border: "none",
                                bottom: 0,
                                right: 0,
                                zIndex: 10,
                            }}>
                            <Button
                                size='large'
                                style={{
                                    borderRadius: "4px",
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                    marginLeft: "130px",
                                }}
                                disabled={!sendEmail.subject || !sendEmail.body || emailIsSending}
                                onClick={() => {
                                    if (sendEmail.cc && sendEmail.body && sendEmail.subject) {
                                        setEmailIsSending(true);
                                        message.info("Email is being sent! Please wait...");
                                        const formData = new FormData();
                                        for (const key in sendEmail) {
                                            if (sendEmail.hasOwnProperty(key) && key !== "attachments") {
                                                formData.append(key, sendEmail[key]);
                                            }
                                        }
                                        // formData.append('data',sendEmail);

                                        sendEmail.attachments.forEach((file, index) => {
                                            formData.append(`attachments`, file);
                                        });
                                        formData.append("permission_category",JSON.stringify(["CUSTOMER_SUPPORT"]))

                                        replycustomercomplains({
                                            requestData: formData,
                                            bodyType:"formData",
                                            resFinalCallback: () => {
                                                setEmailIsSending(false);
                                            },
                                            res200Callback: () => {
                                                message.success("Email sent successfully");
                                                fetchmailreplies({
                                                    requestData: { uuid: selectedRow.uuid },
                                                    res200Callback: (res) => {
                                                        setReplylist(res.data.email_replies);
                                                    },
                                                });
                                                setReplyEmail(false);
                                            },
                                        });
                                    } else {
                                        message.error("Please complete the form");
                                    }
                                }}>
                                Send
                            </Button>
                        </div>
                    </Row>
                </Row>
            </Modal>

            <Modal
                centered
                footer={null}
                title={null}
                visible={discardModal}
                destroyOnClose={true}
                maskClosable={false}
                onCancel={() => setDiscardModal(false)}
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
                }}>
                <Row className={"modal-row"}>
                    <Row>
                        <Icon
                            type='edit'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Discard draft
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                        <Col span={24}>
                            <Text>
                                You haven’t saved the Notification yet. Are you sure you want to leave and discard your
                                draft?
                            </Text>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={18}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "5px",
                                    border: "1px solid #fec708",
                                    backgroundColor: "#FFFFFF",
                                    color: "#fec708",
                                }}
                                onClick={() => setDiscardModal(false)}>
                                Go Back
                            </Button>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={6}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "5px",
                                    border: "none",
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    setDiscardModal(false);
                                    setReplyEmail(false);
                                }}>
                                Discard
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Modal>
        </>
    );
}
